import React from 'react'
import styled from 'styled-components'
import { Button, Block } from '@mote/ui'
import { Content } from '../shared/content'

export const DashboardFooter = ({ className }) => {
  const currentYear = React.useMemo(() => new Date().getFullYear(), [])

  return (
    <Root className={className}>
      <StyledContent>
        <Block align='center' justify='center' gap={8}>
          <CopyrightText>
            &copy; Mote Technologies, Inc. {currentYear}. Brought to you with 💜
            from our global team.
          </CopyrightText>
          <Block layout='horizontal' align='center' gap={12}>
            <Link
              tag='a'
              variant='link'
              href='/PrivacyCenter'
              text='Privacy Center'
            />
            <DotDivider />
            <Link
              tag='a'
              variant='link'
              href='/tos'
              text='Terms & Conditions'
            />
          </Block>
        </Block>
      </StyledContent>
    </Root>
  )
}

const Root = styled.footer`
  width: 100%;
  height: 90px;
  background: transparent;
`

const StyledContent = styled(Content)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const CopyrightText = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 16px;
  color: #716581;
}
`

const Link = styled(Button)`
  span {
    font-size: 14px;
    color: #716581;
  }
`

const DotDivider = styled.span`
  width: 4px;
  height: 4px;
  border-radius: 100%;
  line-height: 100%;
  font-weight: 400;
  background: #716581;
  opacity: 0.8;
  user-select: none;
`
